import { SagaIterator } from 'redux-saga';

import apiClient from '../common/apiClient';

export function getEmployeePermissions(employeeId: string, mvnToken: string): SagaIterator {
  return apiClient.get(
    `${window.API_GATEWAY_URL}/private/web/messages/permissions`,
    { employeeId },
    { headers: { mvnToken } },
  );
}
